import React, { createContext, useContext, useEffect, useMemo } from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { getFeatureFlags } from '../actions/settings';
import { FigoLoadingOverlay } from '../components/common/FigoLoadingOverlay';

const FeatureFlagContext = createContext();

export const FeatureFlagProvider = ({ children }) => {
  const {
    flags,
    loading,
  } = useSelector(({ settings }) => settings.featureFlags, shallowEqual);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getFeatureFlags());
  }, [dispatch]);

  return (
    <FeatureFlagContext.Provider value={flags}>
      {loading ? <FigoLoadingOverlay visible /> : null}
      {children}
    </FeatureFlagContext.Provider>
  );
};

const useFeatureFlag = (featureKey) => {
  const context = useContext(FeatureFlagContext);
  if (!context) {
    throw Error('Feature Flag Context not found');
  }

  const featureFlags = context;
  const featureFlag = useMemo(
    () => !!featureFlags[featureKey],
    [featureFlags, featureKey],
  );
  return featureFlag;
};

const useTermsAndConditions = () => useFeatureFlag(
  'QuoteSiteEBT194633CheckboxesText',
);
const useBillingAddressWarning = () => useFeatureFlag(
  'QuoteSiteEBBillingAddressT209972',
);

const useProp103 = () => useFeatureFlag('CrossAppProp103');
const useBreedsByState = () => useFeatureFlag('CrossAppBreedsByState');
const useCustomerVerification =
  () => useFeatureFlag('QuoteSitesCustomerVerification');

export {
  useBillingAddressWarning,
  useBreedsByState,
  useCustomerVerification,
  useProp103,
  useTermsAndConditions,
};
